import { createFileRoute } from '@tanstack/react-router'
import { ReportCreationWizard } from 'pages/reporting/ReportCreationWizard'
import { FC } from 'react'
import { enforceSiteIdSearchParam } from 'routes/reporting/-searchParams'

const RouteComponent: FC = () => {
  const { siteId } = Route.useSearch()

  return <ReportCreationWizard siteId={siteId} />
}

export const Route = createFileRoute('/reporting/new')({
  component: RouteComponent,
  staticData: {
    title: 'New Report',
  },
  validateSearch: enforceSiteIdSearchParam,
})
